import {
  ContentHistory,
  ContentWorkflow,
  WorkflowState,
} from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import constants from '../../../common/constants';
import MetadataDisplay from './MetadataDisplay';

interface Props {
  workflowId: number;
}

const ContentVersion: React.FC<Props> = ({ workflowId }) => {
  if (!workflowId) {
    return null;
  }
  return <MetadataDisplay label={constants.LABEL_VERSION} value={`${workflowId}.0`} />;
};

export default ContentVersion;
